import React from 'react';

// Registro de telas PERSONALIZADAS. Cada uma e carregada sob demanda (React.lazy) e
// renderizada pelo PersonalizadoHost dentro de um ErrorBoundary. Para adicionar um novo
// personalizado: crie a pasta/componente e registre aqui o slug -> { titulo, componente }.
export const PERSONALIZADOS = {
    'bem-vindo-ti': {
        titulo: 'Bem-vindo à TI',
        componente: React.lazy(() => import('./BemVindoTI/BemVindoTI')),
    },
    'subir-tabelas': {
        titulo: 'Subir Tabelas',
        componente: React.lazy(() => import('./SubirTabelas/SubirTabelas')),
    },
    lancarpromocao: {
        titulo: 'Lançar Promoção',
        componente: React.lazy(() => import('./LancarPromocao/LancarPromocao')),
    },
    promocoes: {
        titulo: 'Promoções',
        componente: React.lazy(() => import('./Promocoes/Promocoes')),
    },
    'app-fluxoprotocolo': {
        titulo: 'Fluxo de Protocolo',
        componente: React.lazy(() => import('./app/fluxoprotocolo/FluxoProtocolo')),
    },
    'caixa-sankhya': {
        titulo: 'Subir Caixa (Sankhya)',
        componente: React.lazy(() => import('./CaixaSankhya/CaixaSankhya')),
    },
    'estoque-viashop': {
        titulo: 'Atualização Estoque ViaShop',
        componente: React.lazy(() => import('./EstoqueViaShop/EstoqueViaShop')),
    },
    'subir-revista-viashop': {
        titulo: 'Subir Revista ViaShop',
        componente: React.lazy(() => import('./SubirRevistaViaShop/SubirRevistaViaShop')),
    },
    'cadastro-codigo-fornecedor': {
        titulo: 'Cadastro de Código de Fornecedor',
        componente: React.lazy(() => import('./CadastroCodigoFornecedor/CadastroCodigoFornecedor')),
    },
    'conferencia-movimentacao': {
        titulo: 'Conferência de Movimentação',
        componente: React.lazy(() => import('./ConferenciaMovimentacao/ConferenciaMovimentacao')),
    },
    'acerto-fornecedor': {
        titulo: 'Acerto Fornecedor',
        componente: React.lazy(() => import('./AcertoFornecedor/AcertoFornecedor')),
    },
    tarefas: {
        titulo: 'Checklist de Tarefas',
        componente: React.lazy(() => import('./Tarefas/Tarefas')),
    },
    'rotina-pos-lancamento': {
        titulo: 'Rotina Pós-Lançamento (Seg/Ter)',
        componente: React.lazy(() => import('./RotinaPosLancamento/RotinaPosLancamento')),
    },
    'conferencia-matinal': {
        titulo: 'Conferência Matinal',
        componente: React.lazy(() => import('./ConferenciaMatinal/ConferenciaMatinal')),
    },
    'importar-ficha-tecnica': {
        titulo: 'Importar Ficha Técnica',
        componente: React.lazy(() => import('./FichaTecnica/FichaTecnica')),
    },
    'memoria-vaults': {
        titulo: 'Memória — Vaults & Acessos',
        componente: React.lazy(() => import('./MemoriaVaults/MemoriaVaults')),
    },
    'conexoes-permissoes': {
        titulo: 'Conexões & Permissões',
        componente: React.lazy(() => import('./ConexoesPermissoes/ConexoesPermissoes')),
    },
    'importacao-revistas': {
        titulo: 'Importação de Revistas',
        componente: React.lazy(() => import('./ImportacaoRevistas/ImportacaoRevistas')),
    },
    'subir-revista-express': {
        titulo: 'Subir Revista Express',
        componente: React.lazy(() => import('./SubirRevistaExpress/SubirRevistaExpress')),
    },
    estoque: {
        titulo: 'Estoque',
        componente: React.lazy(() => import('./Estoque/Estoque')),
    },
    'conferencias-esporadicas': {
        titulo: 'Rotinas Esporádicas',
        componente: React.lazy(() => import('./ConferenciasEsporadicas/ConferenciasEsporadicas')),
    },
    'cadastro-revista': {
        titulo: 'Cadastro de Revista',
        componente: React.lazy(() => import('./CadastroRevista/CadastroRevista')),
    },
    'valor-venda-fornecedor': {
        titulo: 'Valor Venda Fornecedor',
        componente: React.lazy(() => import('./ValorVendaFornecedor/ValorVendaFornecedor')),
    },
    'gerar-vales': {
        titulo: 'Gerar Vales',
        componente: React.lazy(() => import('./GerarVales/GerarVales')),
    },
    'lojas-ativas': {
        titulo: 'Lojas Ativas',
        componente: React.lazy(() => import('./LojasAtivas/LojasAtivas')),
    },
    dbexplorer: {
        titulo: 'DBExplorer Babita',
        componente: React.lazy(() => import('./DBExplorer/DBExplorer')),
    },
    'balanco-estoque': {
        titulo: 'Balanço de Estoque',
        componente: React.lazy(() => import('./BalancoEstoque/BalancoEstoque')),
    },
    'crm-leads': {
        titulo: 'CRM de Leads',
        componente: React.lazy(() => import('./CrmLeads/CrmLeads')),
    },
    'liga-fashion-star': {
        titulo: 'Liga Fashion Star',
        componente: React.lazy(() => import('./LigaFashionStar/LigaFashionStar')),
    },
    'ficha-parceiros': {
        titulo: 'Ficha de Revendedores',
        componente: React.lazy(() => import('./FichaParceiros/FichaParceiros')),
    },
    'mapa-babita': {
        titulo: 'Mapa Babita',
        componente: React.lazy(() => import('./MapaBabita/MapaBabita')),
    },
    'romaneio-planejamento': {
        titulo: 'Romaneio e Planejamento (protótipo)',
        componente: React.lazy(() => import('./RomaneioPlanejamento/RomaneioPlanejamento')),
    },
    'ficha-sicoob': {
        titulo: 'Análise de Ficha Sicoob',
        componente: React.lazy(() => import('./FichaSicoob/FichaSicoob')),
    },
    'credito-pre-aprovado': {
        titulo: 'Análise de Crédito Pré-Aprovado',
        componente: React.lazy(() => import('./CreditoPreAprovado/CreditoPreAprovado')),
    },
    'caixa-loja': {
        titulo: 'Caixa da Loja',
        componente: React.lazy(() => import('./CaixaLoja/CaixaLoja')),
    },
    'desempenho-vendedora': {
        titulo: 'Desempenho de Vendedoras',
        componente: React.lazy(() => import('./DesempenhoVendedora/DesempenhoVendedora')),
    },
    'recarga-fashionstars': {
        titulo: 'Recarga FashionStars',
        componente: React.lazy(() => import('./RecargaFashionStars/RecargaFashionStars')),
    },
    'fashion-passado': {
        titulo: 'Fashion Passado',
        componente: React.lazy(() => import('./FashionPassado/FashionPassado')),
    },
    'campanha-brinde': {
        titulo: 'Campanha de Brinde',
        componente: React.lazy(() => import('./CampanhaBrinde/CampanhaBrinde')),
    },
    'calendario-babita': {
        titulo: 'Calendário Babita',
        componente: React.lazy(() => import('./CalendarioBabita/CalendarioBabita')),
    },
    'cockpit-supervisao': {
        titulo: 'Cockpit da Supervisao',
        componente: React.lazy(() => import('./CockpitSupervisao/CockpitSupervisao')),
    },
    'clientes-liga': {
        titulo: 'Clientes Liga',
        componente: React.lazy(() => import('./ClientesLiga/ClientesLiga')),
    },
    // Tela da LOGISTICA para solicitar a reposicao do Essencial. Renderiza o MESMO card da aba
    // Essencial do Cockpit -- o que muda e quem entra, e isso e decidido no servidor.
    'controle-reposicao-essencial': {
        titulo: 'Controle reposição Essencial',
        componente: React.lazy(() => import('./ControleReposicaoEssencial/ControleReposicaoEssencial')),
    },
    // Consulta de produto da equipe: foto, tamanhos, codigo de cada item e estoque por loja (so leitura).
    'pesquisa-produtos': {
        titulo: 'Pesquisa de Produtos',
        componente: React.lazy(() => import('./PesquisaProdutos/PesquisaProdutos')),
    },
    'cockpit-gerente-moda': {
        titulo: 'Cockpit Gerente de Moda',
        componente: React.lazy(() => import('./CockpitModa/CockpitModa')),
    },
    'estoque-prod-conteudo': {
        titulo: 'Estoque para Prod Conteúdo',
        componente: React.lazy(() => import('./EstoqueProdConteudo/EstoqueProdConteudo')),
    },
    // Corrida Estrelada e Super Ofensiva da Liga Fashion Stars: meta, progresso por cliente, resgate e janelas de resgate (so leitura).
    'corrida-liga': {
        titulo: 'Corrida e Super Ofensiva',
        componente: React.lazy(() => import('./CorridaLiga/CorridaLiga')),
    },
    // Quadro de projetos e demandas da TI (substitui os cartazes da parede): status, tamanho, andamento, tags.
    'projetos-demandas': {
        titulo: 'Projetos e Demandas e Rotinas',
        componente: React.lazy(() => import('./ProjetosDemandas/ProjetosDemandas')),
    },
    // Confere o caixa de cartao lancado nas lojas (Think) contra a planilha de vendas da Rede: importa o Excel, marca as
    // lojas e mostra o que bateu, o que diverge e o que falta lancar (+ clientes com conceito 93/94/95/96/99/9). So leitura.
    'conferencia-caixa-rede': {
        titulo: 'Conferência Caixa × Rede',
        componente: React.lazy(() => import('./ConferenciaRede/ConferenciaRede')),
    },
    // Valor da NF que cada fornecedor emite no dia 20 (10% da venda que ele pode fazer no mes): previsao pelo ritmo, lancamentos
    // e calendario, com fator de cobertura medido no historico; valor fixo opcional; congelar/PDF/Excel. Financeiro, Fiscal e TI.
    'previsao-nf-fornecedor': {
        titulo: 'Valor de NF por fornecedor',
        componente: React.lazy(() => import('./PrevisaoNf/PrevisaoNf')),
    },
    // Reparte o valor a pedir a um fornecedor entre as lojas (teto por loja/mes): quantidade de cada peca sai sozinha, ajustavel; mostra o que falta. Financeiro, Fiscal e TI.
    'divisao-valor-fornecedor': {
        titulo: 'Divisão de valor por fornecedor',
        componente: React.lazy(() => import('./DivisaoValorFornecedor/DivisaoValorFornecedor')),
    },
    // Proposta do sistema de conferencia de fotos x planilha x Tabela do Marketing: video, prototipo clicavel e desenho (so mostra, nao grava).
    'mesa-conferencia': {
        titulo: 'Mkt - Mesa Conferencia',
        componente: React.lazy(() => import('./MesaConferencia/MesaConferencia')),
    },
    // Clientes que ainda nao chegaram a R$ 3.200 em 3 meses (2 fechados + o atual), com vendedora, loja, quanto falta, quem zerou o mes
    // e quem saiu da carencia de nova/reativada. Filtros por vendedora e loja. So leitura. TI, Diretoria e a lista da pagina em Paginas Internas.
    'perdendo-ficha': {
        titulo: 'Perdendo a Ficha',
        componente: React.lazy(() => import('./PerdendoFicha/PerdendoFicha')),
    },
    // Cheques Devolvidos (29/10/2026): o Financeiro envia o extrato do banco (PDF ou texto colado) e a tela acha o "DEV CH NAC" e lista os cheques
    // devolvidos achados (ou diz que nao ha). Nao consulta o Sankhya. So leitura, nada fica guardado. TI, Diretoria e a lista da pagina em Paginas Internas.
    'cheques-devolvidos': {
        titulo: 'Cheques Devolvidos',
        componente: React.lazy(() => import('./ChequesDevolvidos/ChequesDevolvidos')),
    },
    // Tela da VENDEDORA (do app Lovable da Liga): resumo da carteira + aba Lista (Feliz Aniversário, Perdendo a Ficha, Corrida Comercial,
    // com Editar/WhatsApp/Fiz contato/Respondeu) + aba Ficha (CPF -> Liga, Top 30, metas, aniversário, Super Ofensiva). Conta restrita da vendedora
    // vê só a própria carteira; TI/Diretoria escolhem a vendedora; Gerente as da própria loja. Lê o bd_think e grava só o "Fiz contato".
    'area-vendedora': {
        titulo: 'Área da Vendedora',
        componente: React.lazy(() => import('./AreaVendedora/AreaVendedora')),
    },
    // Clientes novas (1a compra na Babita, minimo R$ 2.000) e reativadas (voltaram depois de parada, minimo R$ 1.500) que compraram no
    // periodo (padrao: semana anterior), com contato, endereco, loja, vendedora, data e valor, e Excel. So leitura. TI, Gestao, Tomas e a lista da pagina em Paginas Internas.
    'clientes-novas-reativadas': {
        titulo: 'Clientes Novas e Reativadas',
        componente: React.lazy(() => import('./ClientesNovasReativadas/ClientesNovasReativadas')),
    },
    // Hits e Erros (26/10/2026): escolhe a revista e mostra, por peca, HIT / PADRAO / ERRO nos 4 primeiros dias uteis do lancamento
    // (HIT >= 70% e ERRO < 25,6% do Pedido Gestao; so pecas com entrega > 80% do pedido), com Excel. Venda e entrega do banco; o Pedido Gestao
    // e a data de lancamento a Gestao preenche na tela. TI, Gestao, Tomas e a lista da pagina em Paginas Internas.
    'hits-e-erros': {
        titulo: 'Hits e Erros',
        componente: React.lazy(() => import('./HitsErros/HitsErros')),
    },
    'calendario-marketing-tarefas': {
        titulo: 'Calendário Marketing Tarefas',
        componente: React.lazy(() => import('./CalendarioMktTarefas/CalendarioMktTarefas')),
    },
    // Giro de Revistas (27/10/2026): giro Regular e Especiais, por fornecedor e resumo por segmento (as abas GIRO REGULAR, GIRO ESPECIAIS e
    // POR_FORNECEDOR da planilha da Gestao), com imagem para o WhatsApp. Le o bd_think e o Pedido Gestao do Hits e Erros. So leitura.
    // TI, Gestao, Tomas e a lista da pagina em Paginas Internas.
    'giro-revistas': {
        titulo: 'Giro de Revistas',
        componente: React.lazy(() => import('./GiroRevistas/GiroRevistas')),
    },
    // ANTIGO endereco da tela separada "Projetos e Demandas e Rotinas" (22/10/2026): virou uma VISAO (Calendario) da tela
    // Projetos e Demandas, que agora tem esse nome. O endereco antigo segue abrindo a mesma tela, para nao quebrar link nem menu.
    'projetos-demandas-rotinas': {
        titulo: 'Projetos e Demandas e Rotinas',
        componente: React.lazy(() => import('./ProjetosDemandas/ProjetosDemandas')),
    },
    // Painel TI: o semaforo do papel de parede TI Painel (LiveWall) -- servidores, bancos, servicos, sites, backups e projetos,
    // testados no back do Central com cache curto. Lista de monitores = monitores.json do pack. So leitura. TI e Diretoria.
    'painel-ti': {
        titulo: 'Painel TI',
        componente: React.lazy(() => import('./PainelTi/PainelTi')),
    },
    // Consulta Nota Gerentes: a gerente consulta a nota do pedido da revendedora (parceiro/CPF-CNPJ com os vinculados, periodo, Liga e
    // estrelas), mas SO a de vendedora da loja do cadastro dela (a trava e no servidor). Uma tela por canal. So leitura.
    'consulta-nota-gerentes-viashop': {
        titulo: 'Consulta Nota Gerentes ViaShop',
        componente: React.lazy(() => import('./ConsultaNotaGerentes/ConsultaNotaViaShop')),
    },
    'consulta-nota-gerentes-express': {
        titulo: 'Consulta Nota Gerentes Express',
        componente: React.lazy(() => import('./ConsultaNotaGerentes/ConsultaNotaExpress')),
    },
    // Separacao de Estoque (23/10/2026): divide o estoque da Logistica com o Express (Loja 2). Marca principal + revista -> ultimo documento
    // usado, divisao item a item e GRAVACAO dos documentos TS/TE no banco da Logistica (senha + primeiro documento). Logistica e TI.
    'separacao-estoque': {
        titulo: 'Separação de Estoque',
        componente: React.lazy(() => import('./SeparacaoEstoque/SeparacaoEstoque')),
    },
    // Gerenciar Tutoriais (26/10/2026): a TI cria grupos e tutoriais, envia video e escreve o manual da pagina publica /tutoriais. So TI/Administrador
    // (o servidor confere em toda rota). A entrada de menu em Paginas Internas, restrita a TI, e criada a parte.
    'tutoriais-admin': {
        titulo: 'Gerenciar Tutoriais',
        componente: React.lazy(() => import('./TutoriaisAdmin/TutoriaisAdmin')),
    },
    // Defeitos (28/10/2026): defeito de fabricacao reclamado pela cliente. A loja registra e imprime formulario + rotulo; a Logistica trata
    // com o fornecedor (prazos em dias uteis) e devolve para a loja. Papel (loja / Logistica / TI / leitura) e recorte por loja no servidor.
    defeitos: {
        titulo: 'Defeitos (Retrologística)',
        componente: React.lazy(() => import('./Defeitos/Defeitos')),
    },
};
